module.exports = __webpack_public_path__ + "img/serviceState0.c261a450.webp";